/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
'use strict';

import React from 'external/react';
import {
    AppContext,
    ContextContainer,
    DataLinkContainer,
    PortletComponent,
    wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';
import Map from '../components/Map';
import MapConfigActions from '../actions/MapConfigActions';
import MapConfigForm from './MapConfigForm';
import { getMapConfigStore } from '../stores/StoreFactory';

const MapC = DataLinkContainer.link(Map, {
    mapConfig: getMapConfigStore(AppContext)
});

const MapConfigFormHoc = wrapWithCommonFormContainer(MapConfigForm);

const MapConfigStore = getMapConfigStore(AppContext);

class MapWidget extends PortletComponent {

    constructor(props) {
        super(props);

        this.DATA = {
            SELECTED_MAP_CONFIG: this.withCtx('SelectedMapconfig'),
        };

        this.MAP_ID = `${this.plid}_${this.portletId}`;
    }

    getChildContext() {
        return { contextId: this.MAP_ID };
    }

    static getStores() {
        return [ MapConfigStore ];
    }

    static calculateState(prevState, undefined, DATA) {
        return {
            ...prevState,
            defaultMapConfig: MapConfigStore.getRemoteData(DATA.SELECTED_MAP_CONFIG),
        };
    }

    componentDidMount() {
        super.componentDidMount();
        MapConfigActions.itemDefaultGrouped(this.DATA.SELECTED_MAP_CONFIG, { groupId: this.props.scopeGroupId });
    }

    renderConfigForm(props) {
        return (<MapConfigFormHoc {...props} {...this.state}/>);
    }

    renderPortlet(config) {
        return (
            <MapC
                style={{ height: config.height + 'px' }}
                mapKey={this.MAP_ID}
                mapConfig={this.DATA.SELECTED_MAP_CONFIG}
                portletConfig={config}
            />
        );
    }
}

export default ContextContainer.create(MapWidget);



// WEBPACK FOOTER //
// ./js/widgets/MapWidget.jsx